import { defineMessages } from "react-intl";

export const messages = defineMessages({
    usersBlurb: {
        id: "users.blurb",
        defaultMessage: "Create and manage users across your organisation",
    },
    usersCreateButton: {
        id: "users.create.button",
        defaultMessage: "Create a new user",
    },
    // Login
    authLoginEmail: {
        id: "auth.login.email",
        defaultMessage: "Email",
    },
    authLoginPassword: {
        id: "auth.login.password",
        defaultMessage: "Password",
    },
    authLoginLogin: {
        id: "auth.login.login",
        defaultMessage: "Login",
    },
    // User entity
    userEntitySingular: {
        id: "users.user.entity_singular",
        defaultMessage: "User",
    },
    userEntityPlural: {
        id: "users.user.entity_plural",
        defaultMessage: "Users",
    },
    userEntityDefiniteArticle: {
        id: "users.user.entity_definite_article",
        defaultMessage: "the user",
    },
    userEntityDemonstrative: {
        id: "users.user.entity_demonstrative",
        defaultMessage: "this user",
    },
    userEntityIndefiniteArticle: {
        id: "users.user.entity_indefinite_article",
        defaultMessage: "a user",
    },
    userColumnName: {
        id: "users.columns.name",
        defaultMessage: "Name",
    },
    userColumnEmail: {
        id: "users.columns.email",
        defaultMessage: "Email",
    },
    userColumnPassword: {
        id: "users.columns.password",
        defaultMessage: "Password",
    },
    userColumnOrganisation: {
        id: "users.columns.organisation",
        defaultMessage: "Organisation",
    },
    userColumnRoles: {
        id: "users.columns.roles",
        defaultMessage: "Roles",
    },
    userColumnCreatedAt: {
        id: "users.columns.created_at",
        defaultMessage: "Created",
    },
    userColumnUpdatedAt: {
        id: "users.columns.updated_at",
        defaultMessage: "Updated",
    },
});
